module.exports = __webpack_public_path__ + "img/ukjent_annet_paavirkning_introduserte_arter_sykdommer.bdf1c9e5.jpg";